var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editor1",attrs:{"id":"editor1","className":"editor1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }